import Vue from 'vue'
import VueRouter from 'vue-router'
import nav from '@/components/nav.vue'
import login from '@/views/login.vue'
import home from '@/views/home.vue'
//系统管理
import user from '@/views/system/user.vue'
import menu from '@/views/system/menu.vue'
import jurisdiction from '@/views/system/jurisdiction.vue'
import role from '@/views/system/role.vue'
import configure from '@/views/system/configure.vue'
import systemMessage from '@/views/system/systemMessage.vue'
//客户管理
import customer from '@/views/customer/customer.vue'

//商品管理
import goodsList from '@/views/goods/goodsList.vue'
import goodsType from '@/views/goods/goodsType.vue'
import supplier from '@/views/goods/supplier.vue'

//推广管理
import video from '@/views/extension/video.vue'
import bannerList from '@/views/extension/bannerList.vue'
import advertisement from '@/views/extension/advertisement.vue'
import task from '@/views/extension/task.vue'
import sign from '@/views/extension/sign.vue'

import newList from '@/views/extension/newList.vue'
import notice from '@/views/extension/notice.vue'

//拼团商品管理
import collageGoodsList from '@/views/collageGoods/collageGoodsList.vue'
import collageGoodsType from '@/views/collageGoods/collageGoodsType.vue'

//订单管理
import chargebackList from '@/views/order/chargebackList.vue'
import orderList from '@/views/order/orderList.vue'

//提现管理
import withdrawal from '@/views/withdrawal/withdrawalList.vue'

//业绩申报
import declaration from '@/views/declaration/declarationList.vue'

//运营商管理
import operation from '@/views/operation/operationList.vue'
import earningsRecords from '@/views/operation/earningsRecords.vue'

//实体云账本
import cloudLedgerList from '@/views/cloudLedger/list.vue'
import cloudLedgerApplyList from '@/views/cloudLedger/applyList.vue'

//推广中心
import spreadCensus from '@/views/spread/census.vue'
import spreadList from '@/views/spread/list.vue'


//商家管理
import shopCate from '@/views/shop/shopCate.vue'
import shopApplyList from '@/views/shop/shopApplyList.vue'
import shopList from '@/views/shop/shopList.vue'
import store from '../store/index'
Vue.use(VueRouter)
const routes = [{
		path: '/',
		name: '登录',
		hidden: true,
		component: login,
		meta: {
			requireAuth: false
		}
	},

	//主页
	{
		path: '/',
		component: nav,
		name: "主页",
		iconCls: 'el-icon-message', //图标样式class
		hidden: true,
		children: [{
			path: '/home',
			name: '主页',
			component: home,
			meta: {
				requireAuth: true
			}
		}, ]
	},

	//系统管理
	{
		path: '/',
		component: nav,
		name: "系统管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
				path: '/user',
				name: "管理员列表",
				component: user,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/menu',
				name: "菜单列表",
				component: menu,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/jurisdiction',
				name: "权限管理",
				component: jurisdiction,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/role',
				name: "角色管理",
				component: role,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/configure',
				name: "基础配置",
				component: configure,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/systemMessage',
				name: "公告消息",
				component: systemMessage,
				meta: {
					requireAuth: true
				}
			},
		]

	},

	//客户管理
	{
		path: '/',
		component: nav,
		name: "客户管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/customer',
			name: "客户管理",
			component: customer,
			meta: {
				requireAuth: true
			}
		}, ]
	},
	//提现管理
	{
		path: '/',
		component: nav,
		name: "提现管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/withdrawal',
			name: "提现列表",
			component: withdrawal,
			meta: {
				requireAuth: true
			}
		}, ]
	},
	//业绩申报管理
	{
		path: '/',
		component: nav,
		name: "业绩申报管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/declaration',
			name: "申报列表",
			component: declaration,
			meta: {
				requireAuth: true
			}
		}, ]
	},

	//商品管理
	{
		path: '/',
		component: nav,
		name: "商品管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
				path: '/goodsList',
				name: "商品列表",
				component: goodsList,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/goodsType',
				name: "商品类型",
				component: goodsType,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/supplier',
				name: "商品供货商",
				component: supplier,
				meta: {
					requireAuth: true
				}
			}
		]
	},

	//推广管理
	{
		path: '/',
		component: nav,
		name: "推广管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
				path: '/video',
				name: "签到视频",
				component: video,
				meta: {
					requireAuth: true
				}
			},

			{
				path: '/task',
				name: "任务视频",
				component: task,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/sign',
				name: "签到视频",
				component: sign,
				meta: {
					requireAuth: true
				}
			},
			{
				path: '/bannerList',
				name: "轮播管理",
				component: bannerList,
				meta: {
					requireAuth: true
				}
			}, {
				path: '/advertisement',
				name: "广告管理",
				component: advertisement,
				meta: {
					requireAuth: true
				}
			}, {
				path: '/newList',
				name: "商学院",
				component: newList,
				meta: {
					requireAuth: true
				}
			}, {
				path: '/notice',
				name: "公告",
				component: notice,
				meta: {
					requireAuth: true
				}
			},
		]
	},

	//拼团管理
	{
		path: '/',
		component: nav,
		name: "拼团管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/collageGoodsList',
			name: "拼团列表",
			component: collageGoodsList,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/collageGoodsType',
			name: "拼团分类",
			component: collageGoodsType,
			meta: {
				requireAuth: true
			}
		}, ]
	},

	//订单列表
	{
		path: '/',
		component: nav,
		name: "订单列表",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/orderList',
			name: "订单列表",
			component: orderList,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/chargebackList',
			name: "退货订单",
			component: chargebackList,
			meta: {
				requireAuth: true
			}
		}, ]
	},

	//商家管理
	{
		path: '/',
		component: nav,
		name: "商家管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/shopCate',
			name: "商家分类",
			component: shopCate,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/shopApplyList',
			name: "商家申请列表",
			component: shopApplyList,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/shopList',
			name: "商家列表",
			component: shopList,
			meta: {
				requireAuth: true
			}
		}, ]
	},
	//运营商管理
	{
		path: '/',
		component: nav,
		name: "运营商管理",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/operation',
			name: "运营商列表",
			component: operation,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/earningsRecords',
			name: "奖励发放记录",
			component: earningsRecords,
			meta: {
				requireAuth: true
			}
		}]
	},
	//实体云账本
	{
		path: '/',
		component: nav,
		name: "功绩云账本",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/cloudLedgerList',
			name: "项目列表",
			component: cloudLedgerList,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/cloudLedgerApplyList',
			name: "申请列表",
			component: cloudLedgerApplyList,
			meta: {
				requireAuth: true
			}
		}]
	},
	//推广中心
	{
		path: '/',
		component: nav,
		name: "推广中心",
		iconCls: 'el-icon-message', //图标样式class
		children: [{
			path: '/spreadCensus',
			name: "数据统计",
			component: spreadCensus,
			meta: {
				requireAuth: true
			}
		}, {
			path: '/spreadList',
			name: "任务包配置",
			component: spreadList,
			meta: {
				requireAuth: true
			}
		}]
	},
]

const router = new VueRouter({
	routes
})
router.beforeEach((to, from, next) => {
	// console.log(to, from, next)
	// console.log(store.state.userName)
	if (to.meta.requireAuth) { //判断requireAuth进行一下步骤
		if (store.state.token.length != "") {
			next()
		} else {
			// console.log($message)
			// this.$message({
			//           message: '警告哦，这是一条警告消息',
			//           type: 'warning'
			//         });
			//        // alert('请登录')
			next({
				path: '/'
			})
		}
	} else {
		next()
	}
})
export default router